import React, { Component } from 'react';
import { AxiosGetSecretApi } from '../../../utils/fetchApi';
import StaticClass from '../../../utils/staticClass';
export default class SearchResult10000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'DuAn',
    };

    this.listDuAnTitle = [
      'Mã loại đất',
      'Tên loại đất',
      'MĐSD cũ',
      'Năm quy hoạch',
      'Mặt bằng',
      'Diện tích (ha)',
      'Số quyết định',
      'Nơi ra quyết định',
      'Ngày ra quyết định',
    ];

    this.listDuAnValue = [
      'MaLoaiPolygon',
      'TenLoaiDat',
      'MDSDCu',
      'NamQH',
      'LoaiQH',
      'DienTich',
      'QuyetDinh',
      'NoiRaQD',
      'NgayRaQD',
    ];
  }

  changeTab(e) {
    this.setState({
      activeTab: e,
    });
  }

  render() {
    return (
      <div className='search-500'>
        <div className='search-500-header'>
          Thông tin dự án quy hoạch 1/10000
          <i className='fas fa-times close-icon' onClick={this.props.close}></i>
        </div>

        <div className='search-500-body'>
          {this.listDuAnTitle.map((e, i) => (
            <div style={{ display: 'flex' }} key={i}>
              <div
                className='col-left-10000 search-500-text'
                style={{ marginRight: 0, minWidth: 125 }}
              >
                {e}:
              </div>

              <div
                className='col-right-10000 search-500-text-gray'
                style={{ maxWidth: 200 }}
              >
                {this.props.data[`${this.listDuAnValue[i]}`]
                  ? i === 8
                    ? StaticClass.formatDate(
                        this.props.data[`${this.listDuAnValue[i]}`]
                      )
                    : i === 5
                    ? StaticClass.formatPrice(
                        this.props.data[`${this.listDuAnValue[i]}`]
                      )
                    : this.props.data[`${this.listDuAnValue[i]}`]
                  : '-'}
              </div>
            </div>
          ))}

          {this.props.file &&
            Array.isArray(this.props.file) &&
            this.props.file.length !== 0 && (
              <div style={{ display: 'flex' }}>
                <div
                  className='col-left-10000 search-500-text'
                  style={{ marginRight: 0, minWidth: 125 }}
                >
                  File đính kèm:
                </div>
                <div>
                  {this.props.file.map((e, i) => (
                    <div
                      className='col-right search-500-text'
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '125px',
                        color: '#1e86eb',
                        cursor: 'pointer',
                        maxWidth: 200,
                      }}
                      key={i}
                      onClick={async () => {
                        const response = await AxiosGetSecretApi(
                          `/api/otp-token`
                        );
                        window.open(
                          `${e.Duongdanfiledinhkem}?key=${response.token}`,
                          '_blank'
                        );
                      }}
                    >
                      {e.Tenfiledinhkem}
                    </div>
                  ))}
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}
